// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iHiS","question":"styles_question__1dcy-","description":"styles_description__2INiv"};